// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__-8Dyi","label":"Section_label__3Q8Hu","contentWrap":"Section_contentWrap__3bo4D","footer":"Section_footer__3W26h","footerInner":"Section_footerInner__1GtPV"};